<template>
	<div class="l-content-section -header">
		<div
			class="jumbotron-krone"
			:class="{'is-league': isLeague && !disableSponsor}"
		>
			<div
				class="jumbotron-krone__left"
			>
				<a
					v-if="showBackButton"
					class="jumbotron-krone__nav-back"
					href="#"
					@click="handleBackNavigation"
				>
					<Icon
						icon-name="arrow-left"
						size="xs"
					/>
					{{ $Helpers.ucfirst($I18n.trans('commons.back')) }}
				</a>
				<div class="jumbotron-krone__title-w">
					<h1 class="jumbotron-krone__title">
						{{ title }}
					</h1>
					<h2
						v-if="subtitle"
						class="jumbotron-krone__subtitle"
					>
						{{ subtitle }}
					</h2>
				</div>
			</div>
			<div
				class="jumbotron-krone__right"
			>
				<img
					v-if="isLeague && !disableSponsor"
					class="jumbotron-krone__logo"
					src="/images/krone/presented-by-interwetten.svg"
					alt="Presented by Interwetten"
				>
			</div>
		</div>
		<slot name="after" />
	</div>
</template>

<script>
import Icon from '@shared/components/Icon';

export default {
	name:       'JumbotronKrone',
	components: { Icon },
	props:      {
		title: {
			type:     String,
			required: true,
		},
		subtitle: {
			type:     String,
			required: false,
			default:  null,
		},
		isLeague: {
			type:    Boolean,
			default: false,
		},
		backUrl: {
			type:    String,
			default: null,
		},
	},
	data() {
		return {
			skeleton:           null,
			skeletonFullImages: null,
			disableSponsor:     true, // permanently disabled, remove once we have a proper sponsor
		};
	},
	computed: {
		showBackButton() {
			// Show back button if we have a backUrl or if browser history is available
			return this.backUrl || this.isBrowserHistoryAvailable();
		},
	},
	methods: {
		isBrowserHistoryAvailable() {
			// Check if browser supports history API and has previous pages
			return window.history && window.history.length > 1;
		},
		handleBackNavigation(event) {
			event.preventDefault();

			if (this.backUrl) {
				// If we have a specific back URL, navigate to it
				window.location.href = this.backUrl;
			} else if (this.isBrowserHistoryAvailable()) {
				// Use browser back navigation
				window.history.back();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.jumbotron-krone {
	position: relative;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	padding: $sp4 $sp4;
	height: 116px;
	background: linear-gradient(90deg, var(--color-grey-900) 0%, var(--color-black--dark) 100%);

	&.is-league {
		background-image: url('/images/krone/jumbotron.jpg');
		background-size: cover;
		background-position: center;
		color: var(--color-shadow-grey);
	}

	@include size(md-up) {
		height: 140px;
		padding: $sp4 $sp6;
	}
}

.jumbotron-krone__left {
	display: flex;
	flex-direction: column;
	gap: $sp4;
}

.jumbotron-krone__title-w {
	display: flex;
	flex-direction: column;
	gap: $sp1;
}

.jumbotron-krone__title {
	@include font(primary, bold, normal, fs-170);
	font-weight: 700; // stylelint-disable-line
}

.jumbotron-krone__subtitle {
	@include font(primary, bold, normal, fs-80);
	font-weight: 700; // stylelint-disable-line
}

.jumbotron-krone__logo {
	max-height: 80px;
}

.jumbotron-krone__nav-back {
	font-size: 14px; // stylelint-disable-line
	font-weight: 500; // stylelint-disable-line
	display: flex;
	align-items: center;
	gap: $sp2;
	line-height: 1;
	margin-bottom: $sp2;
	transform: scale(1);
	transition: transform $trans-time-fast;
	transform-origin: left;
	cursor: pointer;

	&:focus,
	&:hover {
		transform: scale(1.03);
	}
}

</style>
